export const appVersions = {
  name: '應用程式版本',
  fields: {
    id: 'ID',
    platform: '平台',
    latestVersion: '最新版本',
    minimumVersion: '最低支援版本',
    appIdentifier: 'Bundle ID / 套件名稱',
    storeUrl: '商店連結',
    releaseNotes: '更新說明',
    enabled: '啟用',
    createdAt: '建立時間',
    updatedAt: '最後更新時間',
  },
  helpers: {
    latestVersion: '低於此版本的用戶將會看到更新提示(例如 1.3.0)。',
    minimumVersion: '低於此版本的用戶將會看到強制更新提示。',
    appIdentifier: 'iOS:Bundle ID(例如 com.greenwiser.app)。Android:套件名稱。',
    storeUrl: 'App Store / Play 商店的直接連結。',
    releaseNotes: '會顯示在更新視窗中,選填。',
    enabled: '關閉時,此平台的用戶不會看到任何更新提示。',
  },
  errors: {
    invalidSemver: '版本格式錯誤,請使用例如 1.2.3 的格式。',
    invalidUrl: '必須以 http:// 或 https:// 開頭。',
    minimumExceedsLatest: '最低版本不能高於最新版本。',
  },
  sections: {
    versions: '版本',
    store: '商店設定',
    prompt: '更新提示',
  },
};
